<template>
    <div>
        <vs-popup title="" 
            :button-close-hidden="true" 
            :active.sync="active"
            @close="$emit('isActiveFalse')"
            style="border-radius: 10px !important;"
            id="newChatFlowsInfos"
        >
            <div class="flex-end-align">
                <vs-icon @click="$emit('isActiveFalse')" class="mr-2" icon="close" 
                style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right; cursor: pointer;"/>
            </div>
            
            <br/>

            <div class="mt-6">
                <div class="text-center">
                    <h3 style="color: #635d5d;"> A Mar.IA é a nova solução de inteligência artificial do Pedbot. </h3>
                </div>

                <div class="text-center mt-3">
                    <span> Infelizmente essa função ainda não está inclusa no seu plano,</span> <br/>
                    <span> fale com nosso time para saber mais! </span>
                </div>

                <div class="text-center mt-10 mb-6">
                    <vs-button @click.stop="redirect()" color="primary" type="filled" size="large" style="border-radius: 15px;">
                        Saber mais sobre a Mar.IA
                    </vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>

    import { formatRouteTenantPath } from '@/utils';

    export default {
        name: 'MariaInfos',
        props: {
            isActive: {
                type: Boolean,
                required: true
            }
        },
        emits: [
            'isActiveFalse'
        ],
        computed: {
            active: {
                get() {
                    return this.isActive;
                },
                set( bool ) {
                    if ( !bool ) {
                        this.$emit('isActiveFalse');
                    }
                }
            }
        },
        methods: {
            redirect() {
                this.$emit('isActiveFalse');
                setTimeout( () => this.$router.push( formatRouteTenantPath('/new-chat-flows/infos') ), 2 );
            }
        }
    }
</script>

<style lang="scss">
    #newChatFlowsInfos div.vs-popup {
        .vs-popup--content {
            padding: 5px;
            margin: 0;
        }
        .vs-popup--header {
            .vs-popup--title {
                h3 {
                    height: 0px !important;
                    padding: 2px !important;
                    background-color: transparent !important;
                }
                background-color: transparent !important;
            }
            background-color: transparent !important;
        }
        header {
            background-color: transparent !important;
        }
        margin: 0;
        border-radius: 18px !important;
        border: solid 1.2px;
        border-color: rgba(255, 255, 255, 0);
        width: 650px !important;
        box-shadow: 6px 5px 0px 0px rgba(70, 58, 58, 0.185) !important;
    }
</style>